import { ImpType } from '../_models/models';

export const FLOOR_TYPES: ImpType[] = ['BANNER', 'VIDEO', 'NATIVE', 'AUDIO'];
